import React from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Guard against AdminLTE 3.2.0 IFrame plugin bug on iframe load
if (typeof window !== "undefined") {
   try {
      if (!localStorage.getItem("AdminLTE:IFrame:Options")) {
         localStorage.setItem("AdminLTE:IFrame:Options", JSON.stringify({ autoIframeMode: false }));
      }
   } catch (e) {}
}

const root = createRoot(document.getElementById("root"));

const queryClient = new QueryClient();

root.render(
   <>
      <BrowserRouter>
         <QueryClientProvider client={queryClient}>
            <Provider store={store}>
               <PersistGate loading={null} persistor={persistor}>
                  <App />
               </PersistGate>
            </Provider>
         </QueryClientProvider>
      </BrowserRouter>
   </>
);

reportWebVitals();
